import React, { Component } from 'react'
import MainForm from '../../components/DetailsForms/MainForm';

class Details extends Component {
    render() {
        return (
            <MainForm />
        )
    }
}

export default Details;
